import * as React from 'react';
import { flow, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { Button, Col, Form } from 'react-bootstrap';
import {
  CancellationReasons,
  IMtaActions,
  IMtaFormNames,
  IMtaState,
  PageForm
} from '../../../../../../../services/mta/models';
import { IStore } from '../../../../../../../redux/IStore';
import { mtaActions, } from '../../../../../../../services/mta/actions';
import CancelHeader from '../components/CancelHeader';
import { CancelReasons } from '../components/CancelReasons/CancelReasons';
import { CallNowButton } from '../components/CallNowButton';
import { push } from 'react-router-redux';
import { isRequired } from '../../../../../../../util/validators';
import { CancellationDiscount, IDiscount } from '../components/CancellationDiscount';
import { CancelRefund } from '../components/CancelRefund';
import { DiscountRefund } from '../components/DiscountRefund';
import Loading from '../../../../../../../components/Loading';
import { MTAButtons } from '../../MTAButtons';
import { Link } from 'react-router-dom';
import { AMTCancelReasonText } from '../components/AMTCancelReasonText';
import { IAuthState } from '../../../../../../../services/auth/models';
import { CancellationButton } from '../components/CancellationButton';
import { MakeAChangeRedirectButton } from '../components/MakeAChangeRedirectButton';
import { addDays, isAfter, parse } from 'date-fns';

interface IAMTCancelReasonProps extends InjectedFormProps<any> {
  mta: IMtaState;
  auth: IAuthState;
  isLoading: boolean;
  formValues: any;
  match: any;
  dispatch: any;
  actions: {
    mta: IMtaActions;
    push: (route: string) => void;
  };
}

interface IAMTCancelReasonState {
  refundAmount: number;
  currency: string;
  showContactCallCenter: boolean;
  showRefund: boolean;
  calculating: boolean;
  showDiscountRefund: boolean;
  calculatedDiscountScheme: any;
  hasErrors: boolean;
  discount: {
    hideDiscount: boolean;
    previousDiscount: number;
    selected: IDiscount;
    isFullDiscount: boolean;
  };
}

class AMTCancelReason extends React.Component<IAMTCancelReasonProps, IAMTCancelReasonState> {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      refundAmount: 0,
      currency: '',
      showContactCallCenter: false,
      showRefund: false,
      calculating: false,
      showDiscountRefund: false,
      calculatedDiscountScheme: null,
      hasErrors: false,
      discount: {
        hideDiscount: false,
        previousDiscount: null,
        selected: null,
        isFullDiscount: false,
      }
    }

    this.handleOnchangeReason = this.handleOnchangeReason.bind(this)
  }

  componentDidMount() {
    const { actions, match, change } = this.props
    let refund = '0';
    const defaultEndorsement = {
      title: 'Policy Cancelled',
      content: 'It has been agreed that this policy is cancelled from the effective date shown above.',
      type: 'generated',
      metadata: {
        code: 'CXX'
      }
    }
    Promise.resolve(actions.mta.getDetailsForCancellation(match.params.id)).then((res) => {
      refund = Math.abs(get(res, 'meta.return_premium.premium.gross', '0')).toFixed(2);
      change('data.meta.max', refund);
      change('data.meta.gross_return_premium', refund);
      change('data.meta.reason.cancellation_notes', get(res, 'meta.return_premium.information.endorsement.content', defaultEndorsement.content));
      change('data.meta.endorsement', get(res, 'meta.return_premium.information.endorsement', defaultEndorsement));
      change('data.meta.endorsement.type', 'generated');
      this.setState({
        refundAmount: parseFloat(refund),
        currency: get(res, 'meta.return_premium.premium.currency', '0')
      })
    })
  }

  handleOnchangeReason(event, data) {
    const { change } = this.props
    this.setState({ showRefund: false, showDiscountRefund: false, calculatedDiscountScheme: null })
    if (data === CancellationReasons.OTHER) {
      change('data.meta.reason.cancellation_notes', '');
    } else {
      change('data.meta.reason.cancellation_notes', 'It has been agreed that this policy is cancelled from the effective date shown above.');
    }

    change('data.meta.endorsement.content', 'It has been agreed that this policy is cancelled from the effective date shown above.');
    this.setDiscount(data);
  }


  private renderCallUs = () => {
    return (
      <>
        <div style={{ marginTop: '30px' }}>
          Since you may have multiple policies that cover you for different situations, please call us on <b>0333 234
          9913</b> so that we can cancel the right one to ensure you have the cover you want.
        </div>
        <div style={{ marginTop: '30px' }}>
          <CallNowButton isBlock={true}/>
        </div>
      </>
    )
  }

  private renderTextField = () => {
    return (
      <Col style={{ margin: '20px 0 0 0', textAlign: 'center' }}>
        <Field
          name="data.meta.reason.cancellation_notes"
          component="textarea"
          maxLength={300}
          placeholder={'Please tell us what went wrong so that we can improve... [max 300 characters]'}
          style={{ resize: 'none', width: '100%', height: '200px', borderRadius: '15px', padding: '15px' }}
          validate={[isRequired]}
        />
      </Col>
    )
  }

  private handleCancelSelected = () => {
    this.setState({ showRefund: true, showDiscountRefund: false })
  }

  private handleDiscountSelected = (discount: IDiscount) => {
    const { actions } = this.props;
    const { calculatedDiscountScheme } = this.state;
    this.setState({ showRefund: false })

    if (calculatedDiscountScheme) {
      this.setState({ showDiscountRefund: true })
      return;
    }

    this.setState({ calculating: true })
    Promise.resolve(actions.mta.calculateCancellationDiscount(discount)).then((data) => {
      const selectedScheme = data.selectedScheme;
      const policyData = data.policyData;
      const hasErrors = !isEmpty(get(selectedScheme, 'declines')) || !isEmpty(get(selectedScheme, 'errors')) || !isEmpty(get(selectedScheme, 'referrals'))
      this.setState({
        calculatedDiscountScheme: selectedScheme,
        hasErrors,
        showDiscountRefund: true
      })

      if (hasErrors) {
        this.setState({ calculating: false })
      }

      if (!hasErrors) {
        Promise.resolve(actions.mta.storeMtaPolicyApplication(policyData)).then(() => {
          this.setState({ calculating: false })
        })
      }
    })

  }

  private setDiscount = (cancellationReason) => {
    const { mta } = this.props;
    const previousDiscount = get(mta, 'policyInfo.meta.discount', null)
    const cancellationOptions = get(mta, 'cancellationOptions');
    const hideDiscount = previousDiscount && previousDiscount >= 25;
    const fullDiscount = !previousDiscount
    const discount = get(cancellationOptions, (cancellationReason + '.amt'), null)
    const discountToShowFromStartDate = Number(get(cancellationOptions, 'discount_to_show_from_start_date_in_days', 0));
    const discountCoolingOff = addDays(parse(get(mta, 'selectedPolicy.commencesAt'), 'dd/MM/yyyy', new Date()), discountToShowFromStartDate);
    let selectedDiscount: IDiscount;
    let partialDiscount = false;

    if (get(discount, 'additional_discount.discount')) {
      partialDiscount = previousDiscount && previousDiscount < 25 && previousDiscount < get(discount, 'additional_discount.discount');
    }

    if (fullDiscount) {
      selectedDiscount = get(discount, 'full_discount')
    }

    if (partialDiscount) {
      selectedDiscount = get(discount, 'additional_discount')
    }

    if (isAfter(new Date(), discountCoolingOff)) {
      selectedDiscount = null;
    }

    this.setState({
      discount: {
        hideDiscount,
        previousDiscount,
        selected: selectedDiscount,
        isFullDiscount: fullDiscount
      }
    })
  }

  private handleIssueDiscount = () => {
    const { actions, mta, formValues } = this.props;
    const { calculatedDiscountScheme, discount } = this.state;
    const reason = formValues?.meta?.reason?.cancellation_reason
    const values = {
      reuseCustomerAddress: true,
      data: {
        attributes: {
          scheme_id: get(mta, 'mtaQuote.data.attributes.metadata.scheme_id')
        }
      }
    }
    Promise.resolve(actions.mta.issueDiscountMTA(values, calculatedDiscountScheme.premium, discount, reason)).then(() => {
      actions.push('/account/make-a-change/discount-applied-complete')
    })
  }

  private renderOptions = () => {
    const { formValues, mta, actions } = this.props;
    const {
      refundAmount,
      currency,
      showRefund,
      calculating,
      calculatedDiscountScheme,
      showDiscountRefund,
      hasErrors,
      discount
    } = this.state;
    const cancellationReason = get(formValues, 'meta.reason.cancellation_reason')
    const ifOtherSelected = cancellationReason === CancellationReasons.OTHER;
    const isInCoolingOff = get(mta, 'policyInfo.meta.isInCoolingOff')
    const isCoverNotSuitable = cancellationReason === CancellationReasons.COVER_NOT_SUITABLE;
    const itsTooExpensive = cancellationReason === CancellationReasons.TOO_EXPENSIVE;
    const itsOther = cancellationReason === CancellationReasons.OTHER;

    if (!cancellationReason) {
      return;
    }

    return (
      <>
        {/*RENDER TEXT FIELD*/}
        {ifOtherSelected && (
          <>
            {this.renderTextField()}
          </>
        )}

        {/*RENDER CARDS*/}
        <div style={{ margin: '40px 0 40px 0' }} className={'cancellation-cards-container'}>

          {(itsTooExpensive || isCoverNotSuitable || itsOther) && (
            <div className={'mt-15'}>
              <MakeAChangeRedirectButton
                calculating={calculating}
                route={`/account/make-a-change/selection/${mta?.selectedPolicy?.id}`}
                push={actions.push}
              />
            </div>
          )}

          {isInCoolingOff && discount?.selected?.code && (
            <div className={'mt-15'}>
              <CancellationDiscount
                handleDiscountSelected={this.handleDiscountSelected}
                discount={discount}
                calculating={calculating}
                {...this.props}
              />
            </div>
          )}

          <div className={'mt-15'}>
            <CancellationButton
              handleCancelSelected={this.handleCancelSelected}
              calculating={calculating}
            />
          </div>
        </div>

        {calculating && (
          <div>
            <Loading/>
            <div>Calculating...</div>
          </div>
        )}

        {showDiscountRefund && !calculating && (
          <DiscountRefund
            selectedScheme={calculatedDiscountScheme}
            hasErrors={hasErrors}
            handleIssue={this.handleIssueDiscount} {...this.props}
          />
        )}

        {showRefund && (
          <CancelRefund
            refundAmount={refundAmount}
            currency={currency}
            formValues={formValues} {...this.props}/>
        )}

      </>
    )
  }

  private goBackButton = () => {
    const { calculating } = this.state;

    return (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          disabled={calculating}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    )
  };

  render() {
    const { mta, auth, formValues } = this.props;
    const { showContactCallCenter, discount } = this.state;
    const policyNumber = get(mta, 'selectedPolicy.policyNumber', null);
    const cancellationReason = get(formValues, 'meta.reason.cancellation_reason')
    const ifDuplicateSelected = cancellationReason === CancellationReasons.BOUGHT_A_DUPLICATE_POLICY;
    const isInCoolingOff = get(mta, 'policyInfo.meta.isInCoolingOff')

    return (
      <>
        <div style={{ maxWidth: '800px', margin: '30px auto 0 auto' }}>
          <CancelHeader
            title={`Cancel Policy ${policyNumber}`}
          />
          <div className={'cancel-text-container'}>
            Tell us why you want to cancel and we might be able to find just the right solution for you.
          </div>
          <div className={'white-card'} style={{ minHeight: '250px' }}>
            {!showContactCallCenter && (
              <Form horizontal={true} autoComplete="off">
                <div className={'cancel-text-container'}>
                  <CancelReasons
                    handleOnchange={this.handleOnchangeReason}
                    selection={cancellationReason}
                  />
                  <AMTCancelReasonText
                    reason={cancellationReason}
                    customerFirstName={auth?.customer?.firstName}
                    isInCoolingOff={isInCoolingOff}
                    discount={discount}
                  />
                  {!ifDuplicateSelected && this.renderOptions()}
                  {ifDuplicateSelected && this.renderCallUs()}
                </div>
              </Form>
            )}
            {showContactCallCenter && (
              <div className="call-center">
                <div>
                  <h3 className="title">WHOOPS!</h3>
                  <p>Unfortunately, we have been unable to make the change you have requested.</p>
                  <p>
                    Please contact us in order to make the change and keep your policy up to date. Details on how to
                    contact
                    us can be found <a target={'_blank'} style={{ cursor: 'pointer' }}
                                       href={'https://www.admiral.com/contact-us/travel'}>here</a>
                  </p>
                  <p>It is important that your details are kept up to date, as incorrect information could invalidate
                    your
                    cover or affect any future claims.</p>
                </div>
              </div>
            )}
          </div>
          <div style={{ marginTop: '15px' }}>
            <MTAButtons button1={this.goBackButton()}/>
          </div>
        </div>

      </>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.CANCEL_FORM,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.CANCEL_FORM);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(state, 'data');
      return {
        mta: state.mta,
        auth: state.auth,
        isLoading: state.mta.isLoading,
        formValues: values,
        initialValues: {
          page: PageForm.MTA_CANCEL,
          data: {
            meta: {
              cancelled_at: new Date(),
              refund: true,
              max: '0.00',
            }
          }
        },
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(AMTCancelReason);
